import { KuxFilteredCategoriesDTO, UIDAStructureTypeEnum } from '@kaltura-ott/tvpil';

import { CategoryChildren } from '../category-children';
import { CategoryStore } from '../category-store';

/**
 * @category Store
 */
export abstract class WidgetStore extends CategoryStore<CategoryChildren> {
  type: UIDAStructureTypeEnum = UIDAStructureTypeEnum.widget;

  constructor(
    props: KuxFilteredCategoriesDTO,
    parentCategoryTree?: KuxFilteredCategoriesDTO,
    children?: CategoryChildren[],
  ) {
    super(props, parentCategoryTree);
    this.children = children || [];
  }
}
